// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"ad6eb26e","462":"5cd2cd1a","903":"57bb9b8c"}[chunkId] + ".chunk.js";
};